import isObject from 'lodash/isObject'

import { FIELD_BIND_TYPE_ENUM } from '@constants'
import { CommandParameterDTO } from '@types'

export const hasObjSrcForCommandRequestData = (
  data: CommandParameterDTO[],
  srcObj: Record<string, string | number> | undefined
) => {
  // проверяем есть ли в параметрах использование srcObj
  const needSrcObj = data
    .map(item => {
      switch (item.type) {
        case FIELD_BIND_TYPE_ENUM.JS: {
          return Boolean(item.value.indexOf('srcObj') !== -1)
        }
        case FIELD_BIND_TYPE_ENUM.FIELD: {
          return true
        }
        case FIELD_BIND_TYPE_ENUM.STATIC: {
          return false
        }
        default:
          return false
      }
    })
    .some(item => item)

  // если есть параметры с использованием srcObj, проверяем дошли ли в нем данные
  if (needSrcObj) {
    if (!isObject(srcObj)) return true

    return !Object.values(srcObj).length
  }

  return false
}
